<template>
  <section class="jsk-block">
    <div class="container">
      <div class="row text-center">
        <div class="col-12">
          <h6 class="text-uppercase text-title">{{ $t("benefits.title") }}</h6>
          <h1>{{ $t("benefits.subtitle") }}</h1>
        </div>
      </div>

      <div class="row mt-5">
        <!-- benefit 1 -->
        <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-1.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("benefits.one") }}</p>
                <p class="mt-3">{{ $t("benefits.oneDescr") }}</p>
             </div>
          </div>
        </div>
        
       <!-- benefit 2 -->
        <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-2.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("benefits.two") }}</p>
                <p class="mt-3">{{ $t("benefits.twoDescr") }}</p>
             </div>
          </div>
        </div>
      </div>  

    <div class="row mt-5">
       <!-- benefit 3 -->
       <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-3.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("benefits.three") }}</p>
                <p class="mt-3">{{ $t("benefits.threeDescr") }}</p>
             </div>
          </div>
        </div>

        <!-- benefit 4s -->
        <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-4.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("benefits.four") }}</p>
                <p class="mt-3">{{ $t("benefits.fourDescr") }}</p>
             </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "benefits"
};
</script>